import React, {Component} from 'react';
import {withStyles} from '@material-ui/core';
import {Helmet} from "react-helmet";
import {metaDescriptions, metaImages, metaTitles} from "../../website-utils/meta";
import ScrollToTopOnMount from "../../website-utils/ScrollToTopOnMount";
import logoBlack from '../../assets/images/logo-black.png';
import shiftPageHero from '../../assets/images/caterspot.jpg';
import {Link} from "react-router-dom";
import config, {AIRTABLE_HOOKS_ROOT, API_ROOT} from "../../config";


class ShiftPageMookata extends Component {
  componentDidMount() {
    window.analytics.page("Shift");
  }

  render() {
    window.prerenderReady = true;

    const {classes} = this.props;

    return (
      <div className={classes.shiftPage}>
        <ScrollToTopOnMount/>
        <Helmet>
          {metaTitles('Server for CaterSpot')}
          {metaDescriptions('Server for CaterSpot from Sep 3rd to Sep 14th, Mon to Fri from 8AM to 11AM in Tanjong Pagar. SGD 13.50 per hour.')}
          {metaImages(`${window.location.origin}${shiftPageHero}`)}
        </Helmet>
        <div className={classes.header}>
          <div className='container'>
            <div className="row justify-content-md-center">
              <div className="col-md-8 col-sm-12">
                <a href={'https://www.singleshift.sg/pros'}>
                  <img className="logo" src={logoBlack}/>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Image */}
        <div id='hero'>
          <div className='container'>
            <div className='row justify-content-md-center'>
              <div className='col-md-8 col-sm-12'>
                <img src={shiftPageHero} className='img-fluid' width='940'/>
              </div>
            </div>
          </div>
        </div>

        {/* Shift Information */}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h1 className={classes.shiftName}>CaterSpot Office</h1>
              <p className={classes.shiftDate}>2 Week Job – Sep 3rd to Sep 14th, Mon to Fri from 8AM to 11AM</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Wage</h3>
              <p className={classes.shiftWage}>SGD 13.50 per hour</p>
            </div>
            <div className='col-md-4 col-sm-6'>
              <h3 className={classes.shiftLabel}>Job Type</h3>
              <p className={classes.shiftJob}>Server</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Address</h3>
              <p className={classes.shiftAddress}>Tanjong Pagar (<a href="https://goo.gl/maps/h9ptz37E1Kv" target="_blank">CaterSpot Office at 89 Neil Road</a>)</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>About CaterSpot</h3>
              <p>Work in the offices of a fast paced Singapore startup! Caterspot is an online marketplace that connects companies and people with great local catering options.</p>
              <p><a href="https://www.techinasia.com/building-foodtech-behemoth">https://www.techinasia.com/building-foodtech-behemoth</a></p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Attire</h3>
              <p>Black T-Shirt</p>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Duties</h3>
              <ul>
                <li>Receive pantry deliveries and stock pantry supplies on fridges and pantry racks</li>
                <li>Set up team breakfast using pantry supplies</li>
                <li>Clean up after breakfast is finished</li>
                <li>Support the customer with ad-hoc requests</li>
              </ul>
            </div>
          </div>
          <div className='row justify-content-md-center'>
            <div className='col-md-8 col-sm-12'>
              <h3 className={classes.shiftLabel}>Comments</h3>
              <p>There will be a short phone interview before being accepted for this job.</p>
            </div>
          </div>
        </div>

        {/* Shift Actions*/}
        <div className='container'>
          <div className='row justify-content-md-center'>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Have an account?</h3>
                <p>Reply YES to the SMS you received.</p>
              </div>
            </div>
            <div className='col-md-4 col-sm-6'>
              <div className={classes.shiftBox}>
                <h3 className={classes.shiftLabel}>Don't have an account?</h3>
                <a href={'https://www.singleshift.sg/pros'}>Sign up</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default withStyles((theme) => ({
  header: {
    padding: '20px 0',
  },
  shiftPage: {
    marginBottom: '50px',
    '& p': {
      fontSize: '16px',
      lineHeight: '25px',
      marginBottom: '20px'
    },
  },
  shiftSection: {
    borderBottom: '1px solid #ccc',
    marginBottom: '30px',
    paddingBottom: '10px',
  },
  shiftName: {
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '35px',
    marginTop: '15px',
    marginBottom: 0,
    [theme.breakpoints.up('md')]: {
      fontSize: '30px',
      lineHeight: '45px',
    },
  },
  shiftLabel: {
    fontSize: '16px',
    lineHeight: '25px',
    fontWeight: 'bold',
    marginBottom: 0,
  },
  shiftBox: {
    border: '1px solid #ccc',
    padding: '15px 10px',
    marginBottom: '20px',
    '& p': {
      marginBottom: '0'
    },
  },
}))(ShiftPageMookata);



// WEBPACK FOOTER //
// ./src/pages/shift-pages/ShiftPageCaterSpot2.js